import React from 'react'
import { Field } from 'redux-form'
import { ListItem, Typography } from '@mui/material'
import { withStyles } from 'tss-react/mui'
import styles from './EditText.style'
import EditTextField from './EditTextField'

interface Props {
  classes: Record<string, string>,
  hint?: string | null,
  title: string,
  name: string,
  [key: string]: any,
}

class EditText extends React.PureComponent<Props> {
  static defaultProps = {
    hint: null,
  }

  render() {
    const {
      classes,
      title,
      name,
      hint,
      ...other
    } = this.props
    return (
      <ListItem disableGutters className={classes.root}>
        <Typography className={classes.title}>{title}</Typography>
        {/* @ts-expect-error redux-form Field types incompatible with React 18.3+ */}
        <Field
          name={name}
          hint={hint}
          component={EditTextField}
          {...other}
        />
      </ListItem>
    )
  }
}

export default withStyles(EditText, styles as any) as unknown as React.ComponentType<Omit<Props, 'classes'>>
